import {BringzzBottomDrawer, BringzzButton, BringzzInput} from "@bringzz/components";
import React from "react";
import useRequest from "../../../hooks/useRequest";

const CollectionCreationDrawer = (
    {   addCollectionOpen,
        setAddCollectionOpen,
        bottomDrawerType,
        selectedCollection,
        newCollectionName,
        setNewCollectionName
    }) => {

    const { sendRequest, loading } = useRequest();

    return(
        <BringzzBottomDrawer
            isOpen={addCollectionOpen}
            close={() => setAddCollectionOpen(false)}
            title={
                bottomDrawerType === 'rename'
                    ? 'Rename Collection'
                    : 'New collection'
            }
        >
            <div className='px-6 py-6'>
                <BringzzInput
                    label='Collection name'
                    placeholder='Enter collection name'
                    defaultValue={selectedCollection.name}
                    containerClassname='w-full'
                    onChange={(e, isValid, newValue) => {
                        setNewCollectionName(newValue);
                    }}
                />
            </div>
            <div className='text-center mb-12 px-4'>
                <BringzzButton
                    className='bg-magic-lilac w-full flex justify-center'
                    size='lg'
                    onClick={async () => {
                        if (bottomDrawerType === 'rename') {
                            await sendRequest({
                                method: 'POST',
                                url: `/module/bookmarkcollection/updateCollection`,
                                data: {
                                    collectionId: selectedCollection.id,
                                    name: newCollectionName
                                }
                            })
                                .then(response => {
                                    if (response.status === 'success')
                                        setAddCollectionOpen(false);
                                })
                                .catch(error => {
                                    console.log(error);
                                });
                        } else {
                            await sendRequest({
                                method: 'POST',
                                url: `/module/bookmarkcollection/createCollection`,
                                data: { name: newCollectionName }
                            })
                                .then(response => {
                                    if (response.status === 'success')
                                        setAddCollectionOpen(false);
                                })
                                .catch(error => {
                                    console.log(error);
                                });
                        }
                    }}
                    disabled={loading || !newCollectionName}
                >
                    {bottomDrawerType === 'rename' ? 'Save' : 'Create'}
                </BringzzButton>
            </div>
        </BringzzBottomDrawer>
    )
}

export default CollectionCreationDrawer;